// License expiration helpers. Dates come from Poseidon /license as DD-MM-YYYY.

const DAY_MS = 86_400_000;

export const parseLicenseExpiration = (date) => {
	if (!date) return null;
	const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(date);
	if (!m) return null;
	const [, dd, mm, yyyy] = m;
	const expiry = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
	return Number.isNaN(expiry.getTime()) ? null : expiry;
};

// Whole days until expiry (negative once expired); null if unparseable.
export const licenseDaysRemaining = (date) => {
	const expiry = parseLicenseExpiration(date);
	if (!expiry) return null;
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	return Math.round((expiry - today) / DAY_MS);
};

// US-style M/D/YYYY for display; falls back to the raw string if unparseable.
export const formatLicenseDate = (date) => {
	const expiry = parseLicenseExpiration(date);
	if (!expiry) return date || '—';
	return `${expiry.getMonth() + 1}/${expiry.getDate()}/${expiry.getFullYear()}`;
};

export const formatLicenseExpiration = (date) => {
	if (!date) return '—';
	const days = licenseDaysRemaining(date);
	const shown = formatLicenseDate(date);
	if (days === null) return shown;
	if (days < 0) return `${shown} (expired)`;
	return `${shown} (${days} day${days === 1 ? '' : 's'} remaining)`;
};

// Tailwind text colour for a days-remaining value.
export const licenseExpiryTone = (days) => {
	if (days === null) return 'text-gray-400';
	if (days < 0) return 'text-red-600 font-semibold';
	if (days <= 30) return 'text-amber-600 font-medium';
	return 'text-gray-700';
};

// Live value from the card's /license fetch, else the last value stored in Back4App.
export const proteusExpiration = (d) =>
	d?.proteuscore_license_expiration || d?.last_proteuscore_license_expiration || null;
export const apolloExpiration = (d) =>
	d?.apollocore_license_expiration || d?.last_apollocore_license_expiration || null;
